export default __webpack_public_path__ + "static/media/single-meye.f65c1c38.png";